module.exports = __webpack_public_path__ + "img/step_import_convert.ce1e5ba4.svg";